// src/utils/getUserRoleFromToken.js

// export function getUserRoleFromToken(token) {
//   try {
//     const payload = JSON.parse(atob(token.split('.')[1]));
//     return payload.role;
//   } catch {
//     return null;
//   }
// }

// src/utils/getUserRoleFromToken.js
export function getUserRoleFromToken(token) {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.role || null;
  } catch {
    return null;
  }
}
